if (!window.customElements.get("deployer-preorder")) {
    window.customElements.define(
      "deployer-preorder",
      class DeployerPreorder extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          document.addEventListener("widebundle:loaded", this.onWideBundleLoaded.bind(this));
        }
  
        disconnectedCallback() {
          document.removeEventListener("widebundle:loaded", this.onWideBundleLoaded.bind(this));
        }
  
        onWideBundleLoaded() {
            /**
             * Appelé quand WideBundle a fini de mettre à jour son formulaire.
            */
            this.onPriceChange();
            document.addEventListener("widebundle:price:change",this.onPriceChange.bind(this));
        }
  
        onPriceChange() {
            const currentVariant = window.wideBundle.getSelectedVariant();
            const currentVariantMetafieldsData = this.findVariantMetafieldsById(currentVariant.id);
            const isPreorder = this.validatePreorderConditions(currentVariantMetafieldsData);
            const atcBtn = document.querySelector("#new-form-atc");
            const productForm = document.querySelector('.product-block form[action*="/cart/add"]')

            if(isPreorder == true){
                this.showPreorderLabel(true, currentVariantMetafieldsData.metafields.preorder_date);
                this.removePreorderProperties(productForm);
                this.addPreorderProperties(productForm);
                if(!atcBtn) return;
                /**
                 * Solution dégueu mais pas d'autre choix car le bouton généré par WideBundle se met à jour 2 fois consécutives.
                 * La MutationObserver ne fonctionne donc pas dessus.
                */
               setTimeout(() => {
                   atcBtn.innerHTML = window.deployerAdapter.preorderLabel;
                }, 1000);
            } else {
                this.removePreorderProperties(productForm);
                this.showPreorderLabel(false, currentVariantMetafieldsData.metafields.preorder_date);
            }

        }
          

        findVariantById(variantId) {
            const variants = this.querySelector('[data-variants]').innerHTML;
            const parsedState = Array.from(JSON.parse(variants));
    
            return parsedState.find((variant) => (variant.id === variantId))
        }

        findVariantMetafieldsById(variantId) {
          const variants = this.querySelector('[data-variants-metafields]').innerHTML;
          const parsedState = Array.from(JSON.parse(variants));

          return parsedState.find((variant) => (variant.id === variantId))
        }

        validatePreorderConditions(variantMetafieldsData) {
            const dateHasPassed = this.dateHasPassed(variantMetafieldsData.metafields.preorder_date);
            if (
                variantMetafieldsData.available == true
                && variantMetafieldsData.metafields.preorder_date != ""
                && dateHasPassed == false 
                && variantMetafieldsData.metafields.preorder_enable == true
            ) {
                return true;
            }
            return false;
        }

        dateHasPassed(date) {
            if(!date || date == "") return true;
            const preorderDate = new Date(date);
            const currentDate = new Date();

            if(preorderDate < currentDate == true) console.warn('Deployer Error: La date est dépassée');
            return preorderDate < currentDate;
        }

        humanReadableDate(date) {
            const options = { weekday: "long", day: "numeric", month: "long" };
            const formattedDate = new Date(date).toLocaleDateString("fr-FR", options);
            return formattedDate;
        }
        
        showPreorderLabel(isPreorder, date) {
            const element = document.querySelector(".deployer-preorder__content");
            if (!element) return;
            
            isPreorder === true
                ? element.classList.remove("hidden") 
                : element.classList.add("hidden");
                        
            if(!date || date == "") return;
            const humanDate = this.humanReadableDate(date); // ex : "lundi 3 octobre"
            element.innerHTML = element.innerHTML.replace('#date#', humanDate);
        }

        addPreorderProperties(productForm) {
            productForm.insertAdjacentHTML('beforeend', `<input type="hidden" class="from-deployer-preorder" name="properties[precommande]" value="Article en Précommande">`);  
        }
        
        removePreorderProperties(productForm) {
            productForm.querySelectorAll('.from-deployer-preorder').forEach(element => element.remove())
        }
          
    });
}
  